import { Link, Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import AdminProfileDropdown from "./AdminProfileDropdown";
import NotificationsDropdown from "../Shared/NotificationsDropdown";
import ErrorBoundary from "./ErrorBoundary";
import DashboardError from "../../pages/Dashboard/DashboardError";
import { ArrowLeft, Menu } from "lucide-react";
import { useState } from "react";
import DashboardBreadcrumbs, {
  buildDashboardBreadcrumbs,
  getDashboardBackHref,
  getDashboardPageTitle,
} from "./DashboardBreadcrumbs";

const AdminLayout = () => {
  const location = useLocation();
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const breadcrumbs = buildDashboardBreadcrumbs(location.pathname);
  const activeTitle = getDashboardPageTitle(breadcrumbs);
  const backHref = getDashboardBackHref(breadcrumbs);

  return (
    <ErrorBoundary
      fallback={<DashboardError />}
      onError={(error, errorInfo) => {
        // Log error to console or error reporting service
        console.error("Admin Dashboard Error:", error, errorInfo);
      }}
    >
      <div className="admin-dashboard flex min-h-screen bg-[#F5F6FA] font-inter text-[#161616]">
        <Sidebar
          mobileOpen={isMobileSidebarOpen}
          onMobileClose={() => setIsMobileSidebarOpen(false)}
        />
        <div className="min-w-0 w-full">
          <header className="sticky top-0 z-[100] border-b border-black/5 bg-white/85 backdrop-blur-xl">
            <div className="mx-auto flex min-h-[68px] w-full max-w-[1440px] items-center justify-between gap-3 px-4 py-3 sm:min-h-[76px] sm:px-8">
              <div className="flex min-w-0 items-center gap-3">
                <button
                  type="button"
                  onClick={() => setIsMobileSidebarOpen(true)}
                  className="grid size-11 shrink-0 place-items-center rounded-2xl border border-black/10 bg-white text-primary shadow-sm transition hover:border-secondary/30 hover:text-secondary lg:hidden"
                  aria-label="Open dashboard navigation"
                >
                  <Menu size={20} />
                </button>
                {backHref && (
                  <Link
                    to={backHref}
                    className="grid size-10 shrink-0 place-items-center rounded-2xl border border-black/10 bg-white text-primary shadow-sm transition hover:border-secondary/30 hover:bg-secondary/10 hover:text-secondary sm:size-11"
                    aria-label="Back to previous dashboard page"
                  >
                    <ArrowLeft size={19} />
                  </Link>
                )}
                <div className="min-w-0">
                  <p className="text-[10px] font-bold uppercase text-secondary sm:text-[11px]">
                    NileWise Control Center
                  </p>
                  <h1 className="truncate text-lg font-bold text-textPrimary sm:text-2xl">
                    {activeTitle}
                  </h1>
                  <DashboardBreadcrumbs items={breadcrumbs} />
                </div>
              </div>
              <div className="flex shrink-0 items-center gap-2 sm:gap-3">
                <div>
                  <NotificationsDropdown />
                </div>
                <AdminProfileDropdown />
              </div>
            </div>
          </header>
          <main className="admin-dashboard-content mx-auto w-full max-w-[1440px] px-4 py-5 sm:px-8 sm:py-6">
            <Outlet />
          </main>
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default AdminLayout;
